import React from 'react';
import { connect } from 'react-redux';
import { Link } from '@leafygreen-ui/typography';

import { getSettingsState } from 'baas-ui/selectors';
import { BaasEnvironment, RootState } from 'baas-ui/types';

import './footer.less';

const baseClassName = 'footer';

interface ReduxStateProps {
  environmentDesc: string;
}

type Props = ReduxStateProps;

const Footer = ({ environmentDesc }: Props) => {
  const uiVersion = process.env.UI_VERSION;
  const serverGitRev = process.env.SERVER_GIT_REV;
  const serverVersion = process.env.SERVER_VERSION;
  const adminSDKVersion = process.env.ADMIN_SDK_VERSION;

  // Only show Admin SDK version in non-production environments
  const shouldShowAdminSDK = environmentDesc && environmentDesc !== BaasEnvironment.Prod && adminSDKVersion;

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}-app-data`}>
        <ul>
          {serverGitRev && (
            <li>
              Server Version:&nbsp;
              <Link href={`https://github.com/10gen/baas/commit/${serverGitRev}`} hideExternalIcon>
                {serverGitRev.substring(0, 10)}
              </Link>
            </li>
          )}
          {serverVersion && (
            <li>
              Server Version:&nbsp;
              <Link href={`https://github.com/10gen/baas/releases/tag/${serverVersion}`} hideExternalIcon>
                {serverVersion}
              </Link>
            </li>
          )}
          {uiVersion && (
            <li>
              UI Version:&nbsp;
              <Link href={`https://github.com/10gen/baas-ui/releases/tag/v${uiVersion}`} hideExternalIcon>
                {uiVersion}
              </Link>
            </li>
          )}
          {shouldShowAdminSDK && (
            <li>
              Admin SDK Version:&nbsp;
              <Link href={`https://github.com/10gen/baas-ui/releases/tag/sdk/v${adminSDKVersion}`} hideExternalIcon>
                {adminSDKVersion}
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState): ReduxStateProps => {
  const { environmentDesc } = getSettingsState(state);
  return {
    environmentDesc,
  };
};

export { Footer as FooterComponent };

export default connect(mapStateToProps)(Footer);
